import React from 'react';
import { Podcast } from 'lucide-react';
const APPLE_PODCAST = 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?file=uploaded%2Fimages%2FRedesigne%202024%2Fpodcast3.png&site=1856&w=73&h=80&user=1516&opt=w3';
const ANCHOR_PODCAST = 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?file=uploaded%2Fimages%2FRedesigne%202024%2Fanchor2.png&site=1856&w=80&h=80&user=1516&opt=w3';
const SPOTIFY_PODCAST = 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?file=uploaded%2Fimages%2FRedesigne%202024%2FSpotify%20BW2.png&site=1856&w=234&h=85&user=1516&opt=w3';
export function PodcastSection() {
  return <section className="py-16 md:py-24 bg-brand-black" data-id="element-173">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-174">
        <div className="flex items-center justify-center gap-3 mb-6" data-id="element-175">
          <Podcast className="w-6 h-6 text-brand-teal" data-id="element-176" />
          <h2 className="text-2xl font-bold text-brand-white uppercase tracking-wide" data-id="element-177">
            Real Time Experience Podcast
          </h2>
        </div>
        <p className="text-brand-gray-400 mb-10" data-id="element-178">
          Tune in to the "Real Time Experience" Podcast with your host:{' '}
          <strong className="text-brand-white" data-id="element-179">Jose Medina</strong>
        </p>

        <div className="flex items-center justify-center gap-8 flex-wrap" data-id="element-180">
          <a href="https://podcasts.apple.com/us/podcast/the-real-time-experience-podcast/id1504703861" target="_blank" rel="noreferrer" className="hover:opacity-80 transition-opacity" data-id="element-181">
            <img src={APPLE_PODCAST} alt="Apple Podcasts" className="block h-[70px] w-auto" data-id="element-182" />
          </a>
          <a href="https://anchor.fm/jose-medina33" target="_blank" rel="noreferrer" className="hover:opacity-80 transition-opacity" data-id="element-183">
            <img src={ANCHOR_PODCAST} alt="Anchor" className="block h-[70px] w-auto" data-id="element-184" />
          </a>
          <a href="https://open.spotify.com/show/5hcxBv8PEfFA2dUmw83iTh" target="_blank" rel="noreferrer" className="hover:opacity-80 transition-opacity" data-id="element-185">
            <img src={SPOTIFY_PODCAST} alt="Spotify" className="block h-[70px] w-auto" data-id="element-186" />
          </a>
        </div>
      </div>
    </section>;
}